import { FC, ReactNode } from 'react';
import { Box, Stack, StackProps, Typography } from '@mui/material';

import { InformationIcon } from '../../icons';

interface IMplInformationMessageProps {
	children: ReactNode;
	alignItems?: StackProps['alignItems'];
}

export const MplInformationMessage: FC<IMplInformationMessageProps> = ({
	children,
	alignItems = 'center',
}) => {
	return (
		<Stack
			direction="row"
			alignItems={alignItems}
			gap={1}
			sx={{ width: '100%' }}
		>
			<Box
				sx={{
					color: 'solutions.600',
					display: 'flex',
					flexShrink: 0,
				}}
			>
				<InformationIcon />
			</Box>
			<Typography variant="l1" color="solutions.600" sx={{ flex: 1 }}>
				{children}
			</Typography>
		</Stack>
	);
};
